import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../../utils/helpers/model.helper';
import { DocumentNumber } from './document-number.model';

export const DOC_NUMBER_SCHEMA = Object.freeze({
    INVOICE: DocumentNumber,
    ESTIMATE: DocumentNumber,
    CREDIT_MEMO: DocumentNumber,
    PURCHASE_ORDER: DocumentNumber,
  }),
  RECORD = generateSchema(DOC_NUMBER_SCHEMA),
  KEYS: any = generateKeys(DOC_NUMBER_SCHEMA);

export class DocNumber extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));

    const selfModel = setInModel(this, [
      {
        key: KEYS.INVOICE,
        value: new DocumentNumber(this.invoice),
      },
      {
        key: KEYS.ESTIMATE,
        value: new DocumentNumber(this.estimate),
      },
      {
        key: KEYS.CREDIT_MEMO,
        value: new DocumentNumber(this.creditMemo),
      },
      {
        key: KEYS.PURCHASE_ORDER,
        value: new DocumentNumber(this.purchaseOrder),
      },
    ]);

    return selfModel as DocNumber;
  }

  get invoice(): DocumentNumber {
    return this.get(KEYS.INVOICE);
  }

  get estimate(): DocumentNumber {
    return this.get(KEYS.ESTIMATE);
  }

  get creditMemo(): DocumentNumber {
    return this.get(KEYS.CREDIT_MEMO);
  }

  get purchaseOrder(): DocumentNumber {
    return this.get(KEYS.PURCHASE_ORDER);
  }
}
